import request from '../utils/request'

export function getInfo() {

    return request({
        url: 'get_info',
        method: 'get'
    });
}

export function getFeeRecord(query) {

    return request({
        url: 'get_fee_record',
        method: 'get'
        ,params:query
    });
}
export function getHistoryFeeRecord(query) {

    return request({
        url: 'history_fee_record',
        method: 'get'
        ,params: query
    });
}

export function bindMember(data) {

    return request({
        url: 'bind',
        method: 'post'
        ,data
    });
}

export function unbindMember(data) {

    return request({
        url: 'unbind',
        method: 'post'
        ,data
    });
}

export function getJsSdkConfig() {

    return request({
        url: 'jssdk',
        method: 'get'
    });
}

export function pay(id,url,cate) {

    return request({
        url: 'pay',
        method: 'post'
        ,data:{'id':id,'url':url,cate:cate}
    });
}


